import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ChecklistResponseDto } from '../dtos/checklist-response.dto';
import { ChecklistListItemResponseDto } from '../dtos/checklist-list-item-response.dto';
import { SaveChecklistRequestDto } from '../dtos/save-checklist-request.dto';
import { ToggleChecklistDisplayRequestDto } from '../dtos/toggle-checklist-display-request.dto';
import { KendoDataSourceResultDto } from '@shared';
import { AppConfigService } from '@core';

@Injectable({ providedIn: 'root' })
export class ChecklistApi {
  private readonly _http = inject(HttpClient);
  private readonly _config = inject(AppConfigService);
  private readonly _baseUrl = `${this._config.versionedApiUrl}/cases/case-types`;

  public getChecklist(caseTypeId: string): Observable<ChecklistResponseDto> {
    return this._http.get<ChecklistResponseDto>(`${this._baseUrl}/${caseTypeId}/checklist`);
  }

  public saveChecklist(caseTypeId: string, request: SaveChecklistRequestDto): Observable<ChecklistResponseDto> {
    return this._http.post<ChecklistResponseDto>(`${this._baseUrl}/${caseTypeId}/checklist`, request);
  }

  public getAllChecklists(): Observable<KendoDataSourceResultDto<ChecklistListItemResponseDto>> {
    return this._http.get<KendoDataSourceResultDto<ChecklistListItemResponseDto>>(`${this._baseUrl}/checklists`);
  }

  public deleteChecklist(caseTypeId: string): Observable<void> {
    return this._http.delete<void>(`${this._baseUrl}/${caseTypeId}/checklist`);
  }

  public toggleChecklistDisplay(caseTypeId: string, request: ToggleChecklistDisplayRequestDto): Observable<void> {
    return this._http.post<void>(`${this._baseUrl}/${caseTypeId}/checklist/toggle-display-on-cases`, request);
  }
}
